import { render, staticRenderFns } from "./IssuePermit.vue?vue&type=template&id=77e3347d&"
import script from "./IssuePermit.vue?vue&type=script&lang=ts&"
export * from "./IssuePermit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports